import axios from "axios";
const Token = JSON.parse(localStorage.getItem("token"))

export const DashboardProfile = async () =>
    await axios.get(process.env.REACT_APP_API_URL + '/employee/profile', {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })

export const DashboardAnnouncement = async () =>
    await axios.get(process.env.REACT_APP_API_URL + '/announcement', {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
        }
    })

export const DashboardCalendar = async () =>
    await axios.get(process.env.REACT_APP_API_URL + '/company/calendar', {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })

export const DashboardCheckEventDay = async (EventDay) =>
    await axios({
        method: 'GET',
        url: process.env.REACT_APP_API_URL + '/company/eventDay/'+EventDay,
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        },
       

    });



// const response = axios.post(url, data, { headers: { "Content-Type": "application/json" } });
    // axios.get(process.env.REACT_APP_API_URL + '/company/eventDay', {
    //     headers: {
    //         "Access-Control-Allow-Origin": "*",
    //         "Content-type": "Application/json",
    //         "Authorization": `Bearer ${Token.access_token}`
    //     },
    //     data : data
    // })